import { setLocalStorageItem } from '@/utils/local-storage/safe-local-storage';

export const writeToLocalStorage = (key: string, value: unknown) => {
  return setLocalStorageItem(key, JSON.stringify(value));
};
